import { useBackupModal } from '@/hooks/useBackupModal';

export default function BackupButton() {
  const { openBackup } = useBackupModal();

  return (
    <button
      onClick={openBackup}
      className="w-9 h-9 rounded-lg bg-background-100 hover:bg-primary-100 flex items-center justify-center cursor-pointer transition-colors group"
      title="Respaldo de Base de Datos"
    >
      <i className="ri-database-2-line text-foreground-600 group-hover:text-primary-700 text-lg transition-colors"></i>
    </button>
  );
}